import {Component, Input} from '@angular/core';

@Component({
	standalone: false,
	selector: 'ngx-season-mark',
	template: `
		<svg *ngIf="mark === 'cauldron'" viewBox="0 0 24 24" aria-hidden="true">
			<path d="M5 10h14M7 10c0 5 2 8 5 8s5-3 5-8M9 8V6M15 8V6M8 18h8" />
		</svg>
		<svg *ngIf="mark === 'crown'" viewBox="0 0 24 24" aria-hidden="true">
			<path d="M4 16l2-8 4 4 2-6 2 6 4-4 2 8zM6 18h12" />
		</svg>
		<svg *ngIf="mark === 'snowflake'" viewBox="0 0 24 24" aria-hidden="true">
			<path d="M12 3v18M5 7l14 10M19 7L5 17M8 4l4 4 4-4M8 20l4-4 4 4" />
		</svg>
		<svg *ngIf="mark === 'pumpkin'" viewBox="0 0 24 24" aria-hidden="true">
			<path d="M12 6c-3 0-6 3-6 7s2 6 6 6 6-2 6-6-3-7-6-7zM12 6V3M12 8v10M9 9c0 4 1 7 3 8M15 9c0 4-1 7-3 8" />
		</svg>
		<svg *ngIf="mark === 'heart'" viewBox="0 0 24 24" aria-hidden="true">
			<path d="M12 19s-7-4.4-7-9a4 4 0 0 1 7-2 4 4 0 0 1 7 2c0 4.6-7 9-7 9z" />
		</svg>
		<svg *ngIf="mark === 'egg'" viewBox="0 0 24 24" aria-hidden="true">
			<path d="M12 4c3 2 5 6 5 10a5 5 0 0 1-10 0c0-4 2-8 5-10z" />
		</svg>
		<svg *ngIf="mark === 'sun'" viewBox="0 0 24 24" aria-hidden="true">
			<circle cx="12" cy="12" r="3.5" />
			<path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8" />
		</svg>
		<svg *ngIf="mark === 'glass'" viewBox="0 0 24 24" aria-hidden="true">
			<path d="M8 4h8l-1 7a3 3 0 0 1-6 0L8 4zM12 14v4M9 20h6" />
		</svg>
	`,
	styles: [`
		:host {
			display: inline-flex;
			color: var(--app-season-tint, currentColor);
		}
		svg {
			width: 1.5rem;
			height: 1.5rem;
			fill: none;
			stroke: currentColor;
			stroke-width: 1.7;
			stroke-linecap: round;
			stroke-linejoin: round;
		}
	`],
})
export class SeasonMarkComponent {
	@Input() mark: string | null = null;
}
